import { AxiosError, AxiosInstance } from 'axios';
import {
  AdminDashStat,
  CreateStaffDto,
  CustomerListType,
  StaffListType,
  StaffType
} from 'service/dto/staff.dto';
import { UserInfoDto } from 'service/dto/user.dto';
import { ApiPaginationOptions } from 'types/general.type';
import { errorHandler } from 'utils';

class ManageStaffService {
  private baseService: AxiosInstance;

  constructor(baseService: AxiosInstance) {
    this.baseService = baseService;
  }

  createStaff = async (createStaffDto: CreateStaffDto) => {
    try {
      const response = await this.baseService.post(
        '/staff/create',
        createStaffDto
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getStaffs = async (
    whereOptions: any,
    paginationOptions: ApiPaginationOptions
  ): Promise<StaffListType> => {
    const response = await this.baseService.get('/staff/list', {
      params: {
        whereOptions,
        paginationOptions
      }
    });
    return response.data;
  };

  getStaff = async (staffId: any): Promise<StaffType> => {
    try {
      const response = await this.baseService.get(`/staff/details/${staffId}`);
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  toggleStaffActive = async (staffId: any) => {
    try {
      const response = await this.baseService.put(
        `/staff/toggle-staff-active/${staffId}`
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  checkIfEmailInUse = async (email: string) => {
    const response = await this.baseService.get(`/staff/email-exists/${email}`);
    return response.data;
  };

  getStaffCustomers = async (
    whereOptions: any,
    paginationOptions: ApiPaginationOptions
  ): Promise<CustomerListType> => {
    const response = await this.baseService.get('/staff/staff-customer', {
      params: {
        whereOptions,
        paginationOptions
      }
    });
    return response.data;
  };

  getAdminDashboardStat = async (): Promise<AdminDashStat> => {
    try {
      const response = await this.baseService.get(`/staff/dashboard/stats`);
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getStaffActivities = async () => {
    try {
      const response = await this.baseService.get(`/staff/activities`);
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getCustomerProspect = async (): Promise<UserInfoDto[]> => {
    try {
      const response = await this.baseService.get(`/staff/customer-prospect`);
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };
}

export default ManageStaffService;
